import { Controller } from "@hotwired/stimulus";

export class EventDayFilterToggleController extends Controller {
  static targets = ["select", "days"];

  connect() {
    this.setVisibility();
  }

  setVisibility() {
    const visible = this.selectTarget.value === "matches_event_day";
    this.daysTargets.forEach((el) => {
      el.hidden = !visible;
    });
  }
}
